// @flow

import React from 'react';
import styled, { css } from 'styled-components';
import type { Theme } from '../../../../../../types';
import { media } from '../../../../../../helpers';

type Props = {
  className: string,
};

const SaveIcon = ({ className }: Props) => (
  <i className={`icon-floppy ${className}`} />
);

export default styled<typeof SaveIcon, Theme, _>(SaveIcon)`
  height: 1.5625rem;
  width: 1.5625rem;
  font-size: 1.3rem;
  line-height: 0;
  &:before {
    vertical-align: middle;
  }
  ${media.lg(css`
    height: 1.25rem;
    width: 1.25rem;
  `)}
`;
